// The component protocol's `DataItem.description` allows 300 characters.
export const MAX_AI_DESCRIPTION_LENGTH = 300;

/**
 * Builds the `dataItemManifestData` and `ai` parts of a settings param's
 * `metadata` from one description, so both Aria versions get the same text.
 * The older Aria core replaces the manifest description with
 * `ai.description`, while Aria V2 reads only the manifest data item, which the
 * editor platform builds from `dataItemManifestData` (it drops `ai`).
 * Keep `description` within MAX_AI_DESCRIPTION_LENGTH characters.
 *
 * Style params don't need this: Aria V2 reads their `ai.description`.
 */
export function withAiDescription({
  displayName,
  description,
}: {
  displayName: string;
  description: string;
}) {
  return {
    dataItemManifestData: { displayName, description },
    ai: { description },
  };
}
